import errorManager from '@/rollbar.js';

const setListener_for_users = (userFormIdentifier, modalUsersOverLimit, userValidation) => {
  $(userFormIdentifier).on('click', function (ev) {
    ev.preventDefault();

    startAnimation_for_users(userFormIdentifier);

    /*
     * Checks overreaching of users created before form submission...
     * It'll send a notification if limit reached or no limit has been set on parent BUs
     */
    let bu_id = $('#units_business_unit').val();
    if ($(userFormIdentifier).data('control-no-limits')) {
      $('button.proceed').show();
      $.ajax({
        url: $(userFormIdentifier).data('url-users'),
        data: { business_unit_id: bu_id },
        success: function (data) {
          var users_limit = data.users_limit;
          var users_purchased = data.users_purchased;
          var users_actual_number = data.users_actual_number;
          var displayAlert = data.displayAlert;
          var limitReached = data.reached;
          const verbMessage = users_actual_number >= users_limit ? 'Hai superato' : 'Stai superando';

          if (displayAlert && users_limit == null) {
            $.getJSON($(userFormIdentifier).data('url-no-limit'), { business_unit_id: bu_id, users_actual_number: users_actual_number });
            stopAnimation_for_users(userFormIdentifier);
            userValidation.submit();
          } else if (displayAlert && limitReached) {
            $(modalUsersOverLimit).data('users_purchased', users_purchased);
            $(modalUsersOverLimit).data('users_limit', users_limit);
            $(modalUsersOverLimit).data('users_actual_number', users_actual_number);
            $(modalUsersOverLimit)
              .find('.modal-body .text')
              .text(
                $(modalUsersOverLimit)
                  .find('.modal-body .text')
                  .text()
                  .replace('%{verb}', verbMessage)
                  .replace('%{users_limit}', users_limit)
                  .replace('%{users_purchased}', users_purchased),
              );
            if (users_actual_number >= users_limit) {
              $('button.proceed').hide();
            }
            $(modalUsersOverLimit).modal('show');
          } else {
            stopAnimation_for_users(userFormIdentifier);
            userValidation.submit();
          }
        },
      });
    } else {
      stopAnimation_for_users(userFormIdentifier);
      userValidation.submit();
    }
  });
};

// Bind click events on action_buttons inside the usersOverLimit modal
const bindModalUsersOverLimitEvents_for_users = (userFormIdentifier, modalUsersOverLimit, userValidation) => {
  console.log('binding modal events...');
  $(modalUsersOverLimit)
    .on('shown.bs.modal', function (e) {
      // Bootstrap does not handle properly multiple modals on the same page...
      // Remove additional modal-backdrop overlays that were created opening up other modals
      if ($('.modal-backdrop').length > 1) {
        $('.modal-backdrop').not(':last').remove();
      }

      const $this_modal = $(this);

      var users_purchased = $this_modal.data('users_purchased');
      var users_limit = $this_modal.data('users_limit');
      var users_actual_number = $this_modal.data('users_actual_number');

      // set the limit_count on modal description
      var text_with_count = $this_modal.find('.modal-body .text').text().replace('%{users_limit}', users_limit);
      $this_modal.find('.modal-body .text').text(text_with_count);

      // cancel the current submit
      $this_modal.find('button.ignore').on('click', function (ev) {
        $this_modal.modal('hide');

        stopAnimation_for_users(userFormIdentifier);

        return false;
      });

      // proceed with form submission
      $this_modal.find('button.proceed').on('click', function (ev) {
        $this_modal.modal('hide');

        stopAnimation_for_users(userFormIdentifier);

        $.getJSON($(userFormIdentifier).data('url-worker'), {
          business_unit_id: $('#units_business_unit').val(),
          users_purchased: users_purchased,
          users_limit: users_limit,
          users_actual_number: users_actual_number,
        });
        userValidation.submit();

        return true;
      });
    })
    .on('hide.bs.modal', function (e) {
      $(this).find('button.proceed').unbind();
      $(this).find('button.ignore').unbind();
    });
};

const startAnimation_for_users = (userFormIdentifier) => {
  // disable submit button & start animation
  $(userFormIdentifier).attr('disabled', true);
  $(userFormIdentifier).find('i').addClass('rotating');
};

const stopAnimation_for_users = (userFormIdentifier) => {
  // enable submit button & stop animation
  $(userFormIdentifier).attr('disabled', false);
  $(userFormIdentifier).find('i').removeClass('rotating');
};

const init = (userFormIdentifier, modalUsersOverLimit, userValidation) => {
  try {
    bindModalUsersOverLimitEvents_for_users(userFormIdentifier, modalUsersOverLimit, userValidation);
    setListener_for_users(userFormIdentifier, modalUsersOverLimit, userValidation);
  } catch (e) {
    errorManager(e);
  }
};

window.UserFormSubmit = {
  init: init,
};
